import { Link } from "react-router-dom";
import { useReveal } from "../lib/useReveal";
import { HandHeart, Users, ShieldCheck, Heart } from "lucide-react";

const PILLARS = [
  { icon: ShieldCheck, label: "Safe classrooms & sanitation" },
  { icon: Users, label: "Quality teachers in every school" },
  { icon: HandHeart, label: "Community-first partnerships" },
  { icon: Heart, label: "Long-term, transparent support" },
];

export default function Mission() {
  const ref = useReveal();

  return (
    <section id="mission" data-testid="mission-section" className="relative py-16 md:py-24 bg-vermilion text-parchment overflow-hidden">
      <span aria-hidden className="ghost-akshara left-[-6vw] top-[-6vh]" style={{ color: "#EDE3CC", opacity: 0.07 }}>ಅ</span>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 grid lg:grid-cols-12 gap-10 items-center">
        <div ref={ref} className="reveal lg:col-span-7 text-center md:text-left min-w-0">
          <span className="section-chip section-chip-coral">Join Our Mission</span>
          <h2 className="mt-3 font-yatra text-3xl sm:text-4xl md:text-5xl leading-tight">
            Join our Mission to <em style={{color:'#C98A2B'}}>Save Learning.</em>
          </h2>
          <p className="mt-4 text-parchment/85 font-display text-base md:text-lg leading-relaxed">
            With your help we can break cycles of neglect, build stable schools, and ensure dignity and hope
            for children who have long been asked to make do with less.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-4 justify-center md:justify-start">
            <Link to="/get-involved#donate" data-testid="mission-donate" className="btn-vermilion !bg-turmeric !text-indigo !shadow-[0_4px_0_#8a5c1c]">
              Donate
            </Link>
            <Link to="/get-involved#volunteer" data-testid="mission-volunteer" className="btn-outline-indigo !border-parchment !text-parchment hover:!bg-parchment hover:!text-vermilion">
              Volunteer
            </Link>
            <Link to="/news#media" className="text-parchment/80 font-display text-sm underline underline-offset-4 hover:text-turmeric">
              Our Supporters
            </Link>
          </div>
        </div>
        <ul className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 gap-3 min-w-0">
          {PILLARS.map((p) => {
            const Icon = p.icon;
            return (
              <li key={p.label} className="flex items-start gap-3 bg-parchment/10 border border-parchment/20 px-4 py-3">
                <Icon className="w-5 h-5 text-turmeric mt-0.5 shrink-0" />
                <span className="font-display text-sm md:text-base leading-snug">{p.label}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
